import { aiChatBotApi } from './aiChatBotApi';
import {
  AI_CHATBOT_SET_LOADING,
  AI_CHATBOT_RECEIVE_MESSAGE,
  AI_CHATBOT_SET_TOKENS,
  AI_CHATBOT_INCREMENT_API_ERROR,
  AI_CHATBOT_RESET_API_ERROR
} from './reducer';
import type { ChatMessageType } from './reducer';

export const removeLoadingDots = (arr: ChatMessageType[] = []) => {
  if (!Array.isArray(arr)) return [];
  const newArr = [...arr];
  if (newArr.length && newArr[newArr.length - 1].text === '__LOADING_DOTS__') {
    newArr.pop();
  }
  return newArr;
};

export const sendAiChatMessage =
  (message: string, latestMessages: ChatMessageType[], tenantName: string) =>
  async (dispatch: any) => {
    dispatch({ type: AI_CHATBOT_SET_LOADING, payload: true });
    try {
      const response = await aiChatBotApi('/tools/enhanced-sql', {
        method: 'POST',
        data: {
          query: message,
          tenant_schema: tenantName
        }
      });
      const data = response.data;
      dispatch({
        type: AI_CHATBOT_SET_TOKENS,
        payload: {
          total_tokens: data.token_usage?.max_tokens,
          unused_tokens: data.token_usage?.remaining_tokens
        }
      });

      if (data.success) {
        dispatch({ type: AI_CHATBOT_RESET_API_ERROR });
        const newPrev = removeLoadingDots(latestMessages);
        if (data && data.ai_explanation) {
          dispatch({
            type: AI_CHATBOT_RECEIVE_MESSAGE,
            payload: [
              ...newPrev,
              {
                text: data.ai_explanation,
                sender: 'bot',
                cache_key: 'cache_key' in data || 'query_cached' in data ? data?.cache_key : null
              }
            ]
          });
        } else {
          dispatch({ type: AI_CHATBOT_INCREMENT_API_ERROR });
          dispatch({
            type: AI_CHATBOT_RECEIVE_MESSAGE,
            payload: [
              ...newPrev,
              { text: 'Something went wrong.', sender: 'bot', errorType: 'api' }
            ]
          });
        }
      } else {
        dispatch({ type: AI_CHATBOT_INCREMENT_API_ERROR });
        const newPrev = removeLoadingDots(latestMessages);
        dispatch({
          type: AI_CHATBOT_RECEIVE_MESSAGE,
          payload: [
            ...newPrev,
            { text: data.error || 'Token error.', sender: 'bot', errorType: 'token' }
          ]
        });
      }
    } catch (e) {
      dispatch({ type: AI_CHATBOT_INCREMENT_API_ERROR });
      const newPrev = removeLoadingDots(latestMessages);
      dispatch({
        type: AI_CHATBOT_RECEIVE_MESSAGE,
        payload: [
          ...newPrev,
          {
            text: 'Something went wrong.',
            sender: 'bot',
            errorType: 'api'
          }
        ]
      });
    } finally {
      dispatch({ type: AI_CHATBOT_SET_LOADING, payload: false });
    }
  };

export const restartAiChat = (messages: ChatMessageType[]) => async (dispatch: any) => {
  try {
    const response = await aiChatBotApi('/threads', {
      method: 'DELETE'
    });

    const data = response.data;
    if (data.success) {
      dispatch({ type: AI_CHATBOT_RESET_API_ERROR });
      // Chat restarted successfully
      dispatch({ type: AI_CHATBOT_RECEIVE_MESSAGE, payload: messages });
    } else {
      console.error('Failed to restart AI chat:', data.error);
    }
  } catch (error) {
    console.error('Failed to restart AI chat:', error);
  }
};
